import type { NovaVersaoDialogProps } from "./types-nova-versao-dialog";
import { useNovaVersaoDialog } from "./use-nova-versao-dialog";
import { NovaVersaoDialogView } from "./view-nova-versao-dialog";

export function NovaVersaoDialog(props: NovaVersaoDialogProps) {
  const vm = useNovaVersaoDialog(props);

  return <NovaVersaoDialogView {...vm} />;
}

export type * from "./types-nova-versao-dialog";
